
// 或作为对象统一导出
export const config = {
    region: "cn",
    appId: "46184b439c37410c8d1fa60131880212"
};
